var _defs, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaptacaoPaciente(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.836,
    height: 55,
    viewBox: "0 0 55.836 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#16679a;}.b{fill:#0899ba;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M42.606,294.13A13.118,13.118,0,0,0,33,298.267a20.106,20.106,0,0,0-12.615-4.389h-.036a19.955,19.955,0,0,0-14.406,6.049A21.365,21.365,0,0,0,0,315.066a1.24,1.24,0,0,0,.349.854,1.188,1.188,0,0,0,.854.349l31.567-.06c.072.084.144.156.217.241a13.231,13.231,0,1,0,9.62-22.319ZM2.441,313.852A18.806,18.806,0,0,1,7.66,301.6a17.537,17.537,0,0,1,12.687-5.315h.036a17.747,17.747,0,0,1,11.136,3.872,13.257,13.257,0,0,0-.457,13.649Zm40.165,4.329a10.823,10.823,0,1,1,10.823-10.823A10.823,10.823,0,0,1,42.606,318.181Zm0,0",
    transform: "translate(0 -265.593)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M92.16,25.489A12.711,12.711,0,1,0,79.449,12.778,12.711,12.711,0,0,0,92.16,25.489Zm0-23.017A10.306,10.306,0,1,1,81.854,12.778,10.306,10.306,0,0,1,92.16,2.472Zm0,0",
    transform: "translate(-71.801 -0.066)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M390.447,375.7H386.78v-3.668a1.2,1.2,0,0,0-2.405,0V375.7h-3.668a1.2,1.2,0,1,0,0,2.405h3.668v3.668a1.2,1.2,0,0,0,2.405,0V378.1h3.668a1.2,1.2,0,0,0,0-2.405Zm0,0",
    transform: "translate(-342.971 -335.136)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaptacaoPaciente);
export default __webpack_public_path__ + "static/media/captacao-paciente.c976172b955d18605382b3af8c74b396.svg";
export { ForwardRef as ReactComponent };